import { Elements } from "@/components";
import Image from "next/image";
import CisionLogo from '@/assets/images/Cision.webp';
import Icon from "@/components/elements/Icon/Icon";
import ArrowRightIcon from '@/assets/icons/ArrowRight.svg';
import { Link } from "@/lib/router";


export const PressAndMedia = () => {
    return (
        <section className="bg-brand-100 px-4 pb-12 sm:px-5 sm:pb-14 md:px-10 md:pb-16 lg:px-[79px]">
            <div className="mx-auto mb-8 flex w-full max-w-[1200px] flex-col items-center justify-center text-center sm:mb-10">
                <Elements.Title title="Press & Media" type="h1" className="text-center text-gray-900 text-4xl md:text-5xl" />
                <Elements.Description description="See the latest news, media mentions, and featured stories about Predictable Benefits." type="medium" className="text-center text-gray-900 text-sm md:text-lg max-w-[725px]" />
            </div>

            <div className="mx-auto max-w-[1100px] rounded-xl bg-brand-50 p-1.5 sm:rounded-2xl sm:p-2">
                <div className="grid grid-cols-1 items-stretch gap-4 rounded-lg bg-gray-50 p-3 sm:gap-5 sm:rounded-xl sm:p-4 md:grid-cols-[360px_minmax(0,1fr)] md:gap-6">
                    <div className="relative mx-auto aspect-[2/1] w-full max-w-[360px] shrink-0 overflow-hidden rounded-lg md:mx-0 md:aspect-auto md:h-full md:min-h-[180px] md:w-full md:max-w-none md:bg-[#063369]">
                        <Image
                            src={CisionLogo}
                            alt="Predictable Benefits"
                            fill
                            sizes="(min-width: 768px) 360px, min(100vw, 360px)"
                            className="object-cover md:object-contain md:object-center"
                        />
                    </div>

                    <div className="flex min-h-0 min-w-0 flex-col items-start justify-start gap-2 sm:gap-3">
                        <div className="flex flex-wrap items-center gap-2">
                            <span className="rounded-lg bg-brand-100 px-2 py-1 text-sm text-brand-700 sm:text-base">Company News</span>
                            <span className="rounded-lg bg-brand-100 px-2 py-1 text-sm text-brand-700 sm:text-base">Press Release</span>
                        </div>

                        <Elements.Title title="Predictable Benefits™ Launches White-Label ICHRA Platform For Benefit Providers To Offer ICHRA In A Matter Of Minutes, While Brokers Stay BOR" type="h3" className="text-gray-900 !text-base sm:!text-lg" />

                        <Elements.Description description="CLEVELAND, March 2, 2026 /PRNewswire-PRWeb/ -- Predictable Benefits™, an end-to-end ICHRA infrastructure platform, today launched out of stealth to give insurance agencies, health insurance brokers, PEOs, TPAs, and carriers the ability to launch a fully branded ICHRA platform in minutes." type="small" className="text-gray-600 !text-xs sm:!text-sm" />

                        <Link to="https://www.prweb.com/releases/predictable-benefits-launches-white-label-ichra-platform-for-benefit-providers-to-offer-ichra-in-a-matter-of-minutes-while-brokers-stay-bor-302700801.html" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-base text-brand-700 no-underline">
                            View Article
                            <Icon src={ArrowRightIcon} className="size-4 shrink-0" />
                        </Link>
                    </div>

                </div>


            </div>
        </section>
    );
};